/**
 * Empty, error or blocking state: a line icon, a sentence, an action.
 * Design System v1.0, section 07. docs/15, section 6.
 */

import type { ReactNode } from 'react';

import { Icon, type IconName } from './Icon.js';

interface EmptyStateProps {
  icon: IconName;
  title?: string;
  text: string;
  children?: ReactNode;
  /** Announces the state to assistive technology: errors use it. */
  role?: 'alert' | 'status';
}

export function EmptyState({ icon, title, text, children, role }: EmptyStateProps) {
  return (
    <div className="empty-state" role={role}>
      <span className="icon-circle"><Icon name={icon} size={28} /></span>
      {title && <h2 className="empty-state__title">{title}</h2>}
      <p className="empty-state__text">{text}</p>
      {children && <div className="empty-state__actions">{children}</div>}
    </div>
  );
}
